import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';

interface CustomersTableHeaderProps {
  className?: string;
}

export const CustomersTableHeader: FC<CustomersTableHeaderProps> = ({
  className,
}: CustomersTableHeaderProps) => {
  const { t } = useTranslation();
  return (
    <TableHeader className={cn(className)}>
      <TableRow className='cursor-auto'>
        <TableHead>{t('customers.table.headers.name')}</TableHead>
        <TableHead>{t('customers.table.headers.totalItems')}</TableHead>
        <TableHead>{t('customers.table.headers.pending')}</TableHead>
        <TableHead>{t('customers.table.headers.completion')}</TableHead>
      </TableRow>
    </TableHeader>
  );
};
